import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../locales/translations';
import FormContainer from './parts';
import SurveyCreateLoader from './parts/SurveyCreateLoader';
import { v4 as uuidv4 } from 'uuid';

function SurveyCreate() {
  const { t } = useTranslation(TranslationsKeys.MANAGEMENT_TOOLS_SURVEY);

  const sectionExample = {
    id: 'sec1',
    title: t('surveyCreation.exampleSection'),
    questions: Array.from({ length: 5 }, () => ({
      id: uuidv4(),
      text: '',
    })),
  };

  return (
    <SurveyCreateLoader>
      <FormContainer defaultValues={{ sections: [sectionExample] }} />
    </SurveyCreateLoader>
  );
}

export default SurveyCreate;
